module.exports = __webpack_public_path__ + "static/media/Dynamo Studio.fd4c4baf.png";